export const HECTARE = 'Ha';
export const HUNDRED_LITRE = '100L';

const options: Record<string, any>[] = [
    {
        key: HECTARE,
        text: HECTARE,
        value: HECTARE
    },
    {
        key: HUNDRED_LITRE,
        text: HUNDRED_LITRE,
        value: HUNDRED_LITRE
    }
];

export { options };
